import React from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import styled from 'styled-components';

import { Spinner, useOrg } from '@atlassian/ptc-common';

import ProfileAboutTeams from './ProfileAboutTeams';
import { type ProfileAboutTeamsProps } from './types';

export function ProfileAboutTeamsWrapper(props: ProfileAboutTeamsProps) {
	const [{ orgId }] = useOrg();

	return orgId ? (
		<ProfileAboutTeams {...props} />
	) : (
		<ProfileAboutTeamsSpinnerWrapper>
			<Spinner size={'small'} />
		</ProfileAboutTeamsSpinnerWrapper>
	);
}

export default ProfileAboutTeamsWrapper;

// eslint-disable-next-line @atlaskit/design-system/no-styled-tagged-template-expression, @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const ProfileAboutTeamsSpinnerWrapper = styled.div`
	display: flex;
	justify-content: center;
	align-items: center;
`;
